// extracted by mini-css-extract-plugin
module.exports = {"btn":"LoginButton-module__btn___3bnS1","btnFb":"LoginButton-module__btnFb___3yo9v"};